export const hotlist = [
  "VEH179512",
  "VEH179514",
  "VEH179511",
  "VEH175652",
  "VEH175624",
  "VEH175625",
  "VEH175628",
  "VEH175629",
  "VEH175632",
  "VEH175633",
  "VEH175634",
  "VEH175636",
  "VEH175637",
  "VEH175638",
  "VEH175642",
  "VEH175643",
  "VEH171559",
  "VEH174152",
  "VEH174153",
  "VEH174154",
  "VEH177613",
  "VEH180052",
  "VEH180053",
  "VEH179399",
  "VEH178750",
  "VEH179398",
  "VEH176753",
  "VEH179396",
  "VEH179397",
  "VEH171880",
  "VEH171881",
  "VEH171885",
  "VEH171886",
  "VEH171887",
  "VEH171888",
  "VEH171889",
  "VEH179243",
  "VEH179241",
  "VEH174108",
  "VEH174118",
  "VEH174093",
  "VEH174110",
  "VEH174109",
  "VEH175321",
  "VEH175322",
  "VEH175325",
];
